import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, Injector, NgModule } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  ApplicationAuthGuard,
  AuthService,
  ErrorHandlerService,
  LibAccordionItemModule,
  LibCloseIconModule,
  LibConsentIconModule,
  LibDropdownMenuModule,
  LibModalModule,
  LibOpenLinkIconModule,
  LibOverlayModule,
  LibSpinnerModule,
  LibTickIconModule,
  URLUtils,
} from '@experian-digital/affordability-library';
import { PortalRoles } from '@experian-digital/affordability-library/src/lib/shared/enums/portal-roles.enum';
import { AppSharedModule } from '@portal-shared/app-shared.module';
import { LibCookieConsentPanelComponent } from '@portal-shared/components/cookie-consent-panel/cookie-consent-panel.component';
import { ApplicationConfigService } from '@portal-shared/services/config.service';
import { SanitizerHttpInterceptor } from '@portal-shared/services/http.interceptor';
import { WindowRef } from '@portal-shared/services/window.service';
import Aura from '@primeng/themes/aura';
import { OAuthModule } from 'angular-oauth2-oidc';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { Observable } from 'rxjs';
import { environment } from '../../src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

export const UK_MOMENT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [AppComponent, LibCookieConsentPanelComponent],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastModule,
    LibConsentIconModule,
    LibTickIconModule,
    LibCloseIconModule,
    LibOpenLinkIconModule,
    LibSpinnerModule,
    AppSharedModule,
    LibModalModule,
    LibAccordionItemModule,
    LibDropdownMenuModule,
    LibOverlayModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    ApplicationConfigService,
    WindowRef,
    AuthService,
    ApplicationAuthGuard,
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ApplicationConfigService) => (): Observable<boolean> | Observable<never> => config.load(),
      deps: [ApplicationConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SanitizerHttpInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: 'environment', useValue: environment },
    { provide: 'portalType', useValue: PortalRoles.Advisor },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: UK_MOMENT_DATE_FORMATS },
  ],
})
export class AppModule {
  constructor(private injector: Injector) {
    URLUtils.injector = this.injector;
  }
}
